import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  ${mobile_xl(css`
    padding: 9px;
    justify-content: center;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

export { Icon };
